export default function Gatter({ x, y, text, testResult }) {
  return (
    <>
      <rect
        x={x}
        y={y}
        width="100"
        height="60"
        fill={
          testResult === undefined
            ? "#eee"
            : testResult
              ? "#38ab18ff"
              : "#b52d1bff"
        }
        stroke="black"
      />
      <text x={x + 38} y={y + 38} fontSize="16">
        {text}
      </text>
    </>
  );
}
